import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ESTADISTICAS_COLUMNAS_TABLAS } from "../../../../containers/estadisticas/tablas-reportes/ColumnasTablas";
import { useQueryParams } from "../../../../containers/helpers/hooks/locationHooks";
import { FiltroFechas } from "../../../../utilities/gestion_fechas/FiltrosFechas";
import { Calendario } from "../../../globales/Calendario";
import { CargandoInformacion } from "../../../globales/estadisticas/CargandoInformacion";
import TituloSeccion from "../../../globales/estadisticas/TituloSeccion";
import { Miga, MigasDePan } from "../../../globales/MigaDePan";
import { useFechaPorDefecto } from "../../hooks/Fechas";
import { DescargarReporte } from "../../Reportes/DescargarReporte";
import TablaSesiones from "./TablaSesiones";
import TablaLibros from "./TablaLibros";
import moment from "moment";
import { useDispatch, useTrackedState } from "../../../../store";
import { ProfesoresAPI } from "../../../../api/ProfesoresAPI";
import { DetalleProfesorAPI } from "../../../../api/estadisticas/DetalleProfesorAPI";
import PropTypes from "prop-types";
import { CancelRequestController } from "../../../../utilities/cancel-request-controller";

/**
 * Este componente tiene la función de cargar todas las estadísticas relacionadas a libros leídos y sesiones de lectura de un profesor con base a un rango de fechas.Por otro lado, también se encarga de transformar los datos estadísticos a formato excel para que puedan ser descargados por el usuario.
 */
const ReporteProfesorComponent = (props) => {
  const { traducciones } = props;
  const {  miga_de_pan, detalle_profesor } = traducciones;
  const {  tabla, resultados, resumen } = detalle_profesor;

  const history = useHistory();
  const state = useTrackedState();
  const queryParams = useQueryParams();
  const parametros = useParams();
  const fechaPorDefecto = useFechaPorDefecto();
  const dispatch = useDispatch();
  const [filtros, setFiltros] = useState({
    fechas: {
      inicio: fechaPorDefecto.fechaInicio,
      fin: fechaPorDefecto.fechaFin
    }
  })

  const [informacionProfesor, setInformacionProfesor] = useState({
    nombre:' ',
  })

  const [rangoFechas, setRangoFechas] = useState({
    inicio: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaInicio),
    fin: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaFin),
  })

  const [estadisticas, setEstadisticas] = useState({
    totalSesionesLectura:0,
    sesionesDeLectura:[],
    librosLeidos:[],
  });

  const [cargando, setCargando] = useState({
    estadisticas: false
  })


  const actualizarFiltros = (fechas) => {
    dispatch({
      type: "SECCION_ESTADISTICAS_FILTROS",
      property: "fechas",
      value: {inicio:fechas[0], fin:fechas[1]}
    })
    setFiltros({
      ...filtros,
      fechas: {
        inicio: fechas[0],
        fin: fechas[1]
      }
    })
  }



  /**
   * transforma la información suministrada por las APIs a una tabla que se puede descargar como excel.
   * @returns tabla para reporte
   */
  const generarInformacionTablaLibros = () => {
    const columnas = ESTADISTICAS_COLUMNAS_TABLAS.ingresoIndividual.librosLeidos.map(col => {
      const traduccion = traducciones?.detalle_profesor?.tabla?.detalle_libros[`${col?.traduccion}`]
      return { nombreColumna: traduccion || col.textoPorDefecto }
    })

    const filas = [];
    estadisticas?.librosLeidos.forEach(ingreso => {
      let fila = [];
      ESTADISTICAS_COLUMNAS_TABLAS.ingresoIndividual.librosLeidos.forEach(col => {
        let valor = ingreso[`${col?.propiedad}`];
        fila.push({ valor: valor })
      })
      filas.push(fila);
    })

    const tabla = {
      columnas: columnas,
      filas: filas
    }
    return tabla;
  }

  /**
   * transforma la información suministrada por las APIs a una tabla que se puede descargar como excel.
   * @returns tabla para reporte
   */
   const generarInformacionTablaSesiones = () => {
    const columnas = ESTADISTICAS_COLUMNAS_TABLAS.ingresoIndividual.sesiones.map(col => {
      const traduccion = traducciones?.detalle_profesor?.tabla?.historial_sesiones[`${col?.traduccion}`]
      return { nombreColumna: traduccion || col.textoPorDefecto }
    })

    const filas = [];
    estadisticas?.sesionesDeLectura.forEach(ingreso => {
      let fila = [];
      ESTADISTICAS_COLUMNAS_TABLAS.ingresoIndividual.sesiones.forEach(col => {
        let valor = ingreso[`${col?.propiedad}`];
        fila.push({ valor: valor })
      })
      filas.push(fila);
    })

    const tabla = {
      columnas: columnas,
      filas: filas
    }
    return tabla;
  }


  useEffect(() => {
    setRangoFechas({
      inicio: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.inicio),
      fin: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.fin),
    })
  }, [filtros, state?.idioma])


  useEffect(() => {
    const abortController = new CancelRequestController();
    setCargando({
      ...cargando,
      estadisticas: true
    })
    const actualizarEstadisticas = async () => {
      const correoProfesor = parametros?.idProfesor;
      await DetalleProfesorAPI
      .obtenerDetalles({correo:correoProfesor, fechaInicio:filtros?.fechas?.inicio, fechaFin:filtros?.fechas?.fin, abortSignal: abortController.signal})
      .then(resultados=>{
        const sesionesLecura = resultados?.sesionesDeLectura.reduce((acc,curr)=>{
          return acc = acc + curr?.numeroSesiones
        },0)
        setEstadisticas({
          ...estadisticas,
          totalSesionesLectura:sesionesLecura,
          sesionesDeLectura:resultados?.sesionesDeLectura,
          librosLeidos:resultados?.librosLeidos
        })
        setCargando({
          ...cargando,
          estadisticas: false
        })
      })
      .catch(error=>console.log(error))
      
    }
    if (filtros?.fechas?.inicio && filtros?.fechas?.fin ) {
      actualizarEstadisticas();
    }

    return ()=>{
      abortController.abort();
      setCargando({
        ...cargando,
        estadisticas: true
      })
    }
  }, [parametros?.idProfesor,JSON.stringify(filtros)])


  useEffect(()=>{
    const cargarinformacionDelProfesor = async ()=>{
      await ProfesoresAPI.obtenerPorCorreo(parametros?.idProfesor)
      .then(resultado=>{
        setInformacionProfesor({
          nombre:resultado?.nombre,
        })
      })
      .catch(error=>console.log(error))
    }
    cargarinformacionDelProfesor();

  },[parametros?.idProfesor])


  return (
    <>
      <MigasDePan>
        <Miga
          texto={miga_de_pan?.estadisticas || 'Estadisticas'}
          alSeleccionar={() => {
            history.push('/estadisticas')
          }} />
        <Miga
          texto={detalle_profesor?.miga_pan?.ingresos_individuales || 'Ingresos individuales (profesores)'}
          alSeleccionar={() => {
            history.push({
              pathname:'/estadisticas/ingresos-individuales/profesores',
              search:`?fechaInicio=${filtros?.fechas?.inicio}&fechaFin=${filtros?.fechas?.fin}`
            })
          }} />
        <Miga
          texto={`${miga_de_pan?.detalle_de || 'Ingresos individuales'} ${informacionProfesor?.nombre || 'N/A'}`}
          esRutaActual={true}
        />
      </MigasDePan>

      <div className="contenido">
        <h1 className="titulos-principales">{`${detalle_profesor.titulo} ${informacionProfesor?.nombre || 'N/A'}`}</h1>
        <p className="informacion-principal">{detalle_profesor.descripcion}</p>

        <div className="border-b onsurface-var2--border-color  md:alineado-verticalmente py-5 mb-8 gap-4">
          <div className="md:w-4/12 xl:w-3/12">
            <Calendario
              fechaPorDefecto={[
                state?.estadisticas?.filtros?.fechas?.inicio || queryParams.get('fechaInicio') || fechaPorDefecto?.inicio,
                state?.estadisticas?.filtros?.fechas?.fin || queryParams.get('fechaFin') || fechaPorDefecto.fin
              ]}
              placeholder={'YYYY-MM-DD ~ YYYY-MM-DD'}
              zIndex={999999}
              fechaMinima={state?.datosInstitucion?.fechaInicioSuscripcion || ''}
              fechaMaxima={moment().format('YYYY-MM-DD')}
              alCambiar={(fechas) => actualizarFiltros(fechas)}
              modoRango
            />
          </div>
        </div>

        {Boolean(cargando?.estadisticas) === true ?
          <CargandoInformacion />
          : <>
            <div className="mb-8">
              <div className="text-center lg:text-left  mt-5 sm:mt-0 ">
                <p className='q5-32 red-inv-var2--color '>
                  <span className='icon-star-full text-30 mr-3'></span>
                  {estadisticas?.totalSesionesLectura}  {estadisticas?.totalSesionesLectura !== 1 ? resumen.plural : resumen.singular}
                </p>
                <p className="r5-14-negro4A">{resumen.descripcion}</p>
              </div>
            </div>

            <TituloSeccion
              titulo={tabla.historial_sesiones.titulo}
              fecha={`${rangoFechas.inicio || 'N/A'} - ${rangoFechas.fin || 'N/A'}`}
              elementosPersonalizados={
                <div className="my-2 w-full flex  justify-center sm:justify-end">
                  <DescargarReporte
                    nombreArchivo={`${traducciones?.detalle_profesor?.historial_sesiones?.nombre_archivo_reporte || 'Libros leidos por'} ${informacionProfesor?.nombre}  (${rangoFechas?.inicio} - ${rangoFechas?.fin})`}
                    tablaInformacion={generarInformacionTablaSesiones()}
                  />
                </div>
              }
            />


            <div className="fondoTabla mt-5 xl:px-10 xl:py-5 rounded-lg">
              <TablaSesiones
                datos={estadisticas?.sesionesDeLectura}
                textosTabla={{ tabla: tabla.historial_sesiones, resultados: resultados }}
              />
            </div>

            <TituloSeccion
              titulo={`${tabla.detalle_libros.titulo} ${informacionProfesor?.nombre || 'N/A'}`}
              fecha={`${rangoFechas.inicio || 'N/A'} - ${rangoFechas.fin || 'N/A'}`}
              elementosPersonalizados={
                <div className="my-2 w-full flex  justify-center sm:justify-end">
                  <DescargarReporte
                    nombreArchivo={`${traducciones?.detalle_profesor?.libros_leidos?.nombre_archivo_reporte || 'Libros leidos por'} ${informacionProfesor?.nombre} (${rangoFechas?.inicio} - ${rangoFechas?.fin})`}
                    tablaInformacion={generarInformacionTablaLibros()}
                  />
                </div>
              }
            />

            <div className="fondoTabla mt-5 xl:px-10 xl:py-5 rounded-lg">
              <TablaLibros
                datos={estadisticas?.librosLeidos}
                textosTabla={{ tabla: tabla.detalle_libros, resultados: resultados }}
              />
            </div>
          </>
        }


      </div>
    </>
  )
}
export default ReporteProfesorComponent;

ReporteProfesorComponent.propTypes = {
  /**
   * Objeto con los textos que se deben renderizar en la sección
   */
  traducciones: PropTypes.object.isRequired,
}